import { AvailableStagingsListContextProvider, GalleryStagingFlowContextProvider, GalleryStagingStackProvider } from 'components/pages/Gallery/common'
import { GalleryAdditionalVisualsContextProvider, GalleryAssignmentContextProvider, GalleryConstantsContextProvider, GalleryDealContextProvider, GalleryOrderContextProvider, GalleryProductContextProvider, GalleryVirtualVisitContextProvider, GalleryVisualSelectionContextProvider, GalleryVisualTypeContextProvider, GalleryVisualsContextProvider, GalleryVisualsDownloadArchiveContextProvider, GalleryVisualsEditingStackProvider, GalleryVisualsFileAPIProvider, GalleryVisualsMetaContextProvider } from 'components/pages/Gallery/_main/contexts'

import { ClientGalleryContextProvider } from 'components/pages/Gallery/_main/ClientGallery/_main'
import { ClientPropertyEmptyVisualsGallery } from '../../ClientPropertyEmptyVisualsGallery'
import { ClientPropertyVisualsGallery } from '../../ClientPropertyVisualsGallery'
import { FC } from 'react'
import { GalleryStagingContextProvider } from 'components/pages/Gallery/pages/GalleryStaging'
import { ThreadContextProvider } from 'components/common/Threads/context'
import { useClientProperty } from '../contexts'

export const ClientPropertyVisualsGalleryPage: FC = () => {

  const { assignmentId } = useClientProperty()

  if (!assignmentId) return (
    <ClientPropertyEmptyVisualsGallery />
  )

  return (
    <GalleryConstantsContextProvider>
      <GalleryAssignmentContextProvider assignmentId={assignmentId}>
        <GalleryDealContextProvider assignmentId={assignmentId} keepPreviousData={true}>
          <GalleryVisualTypeContextProvider assignmentId={assignmentId}>
            <GalleryProductContextProvider assignmentId={assignmentId}>
              <GalleryOrderContextProvider assignmentId={assignmentId}>
                <GalleryVisualsMetaContextProvider assignmentId={assignmentId}>
                  <GalleryVisualsFileAPIProvider assignmentId={assignmentId}>
                  <GalleryVisualsContextProvider assignmentId={assignmentId}>
                    <GalleryVirtualVisitContextProvider assignmentId={assignmentId}>
                      <GalleryVisualSelectionContextProvider assignmentId={assignmentId}>
                        <GalleryAdditionalVisualsContextProvider assignmentId={assignmentId}>
                          <GalleryVisualsDownloadArchiveContextProvider assignmentId={assignmentId}>
                            <GalleryVisualsEditingStackProvider assignmentId={assignmentId}>
                              <GalleryStagingStackProvider>
                                <GalleryStagingFlowContextProvider>
                                  <GalleryStagingContextProvider>
                                    <AvailableStagingsListContextProvider>
                                      <ThreadContextProvider assignmentId={assignmentId}>
                                        <ClientGalleryContextProvider assignmentId={assignmentId}>

                                          <ClientPropertyVisualsGallery />

                                        </ClientGalleryContextProvider>
                                      </ThreadContextProvider>
                                    </AvailableStagingsListContextProvider>
                                  </GalleryStagingContextProvider>
                                </GalleryStagingFlowContextProvider>
                              </GalleryStagingStackProvider>
                            </GalleryVisualsEditingStackProvider>
                          </GalleryVisualsDownloadArchiveContextProvider>
                        </GalleryAdditionalVisualsContextProvider>
                      </GalleryVisualSelectionContextProvider>
                    </GalleryVirtualVisitContextProvider>
                  </GalleryVisualsContextProvider>
                  </GalleryVisualsFileAPIProvider>
                </GalleryVisualsMetaContextProvider>
              </GalleryOrderContextProvider>
            </GalleryProductContextProvider>
          </GalleryVisualTypeContextProvider>
        </GalleryDealContextProvider>
      </GalleryAssignmentContextProvider>
    </GalleryConstantsContextProvider>
  )
}
